import { LegalDocument } from '@/components/legal/LegalDocument'
import { PublicLegalLayout } from '@/components/layout/PublicLegalLayout'
import { privacyPolicy } from '@/lib/legal'

export function PrivacyPolicyPage() {
  return (
    <PublicLegalLayout>
      <LegalDocument
        title={privacyPolicy.title}
        intro={privacyPolicy.intro}
        sections={privacyPolicy.sections}
        alternateLink={{ href: '/terms', label: 'Terms of Service' }}
      />
    </PublicLegalLayout>
  )
}
